import type { ChartRendererProps } from './charts/ChartRendererCore';
import { ChartRendererCore } from './charts/ChartRendererCore';

/**
 * Renders chart data as charts using Recharts library.
 * Supports bar, line, pie, and table chart types with advanced customization.
 * Chart data flows from nativeData only.
 */
export function ChartRenderer(props: ChartRendererProps) {
  const { isLoading = false, error = null, ...rest } = props;
  return <ChartRendererCore isLoading={isLoading} error={error} {...rest} />;
}
